import { NgHttpCachingConfig } from 'ng-http-caching';
import { HttpRequest } from '@angular/common/http';

export const IcHttpCachingConfig: NgHttpCachingConfig = {
  lifetime: 6000 * 10, // cache expire after 60 seconds
  isCacheable: (req: HttpRequest<any>): boolean | undefined => {
    // Don't cache allocations/debit-notes
    if (req.url.includes('allocations/debit-notes')) {
      return false;
    }
    // Service requests and inspections are live (unread counts, comments, status), so never serve them stale
    if (req.url.includes('/service-requests') || req.url.includes('/inspections')) {
      return false;
    }
    // Lipila wallets/balances/routing rules are re-read right after every save, so never serve them stale
    if (req.url.includes('/lipila/')) {
      return false;
    }
    // Lipila wallets/balances/routing rules are re-read right after every save, so never serve them stale
    if (req.url.includes('/lipila/')) {
      return false;
    }
    // Don't cache requests that are marked as failed or retried
    if (req.headers.has('X-Disallow-Cache')) {
      return false;
    }
    // by returning "undefined" normal "ng-http-caching" workflow is applied
    return undefined;
  },
};
